var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"800px","height":"800px","viewBox":"3 3 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15 7L10 12L15 17","fill":"none","stroke":"#fff","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }